<template>
	<el-dialog
		title="扫描验证"
		:visible.sync="showerrorwin"
		width="30%"
		:append-to-body="true"
		lock-scroll
		:show-close="false"
		:close-on-click-modal="false"
		@opened="setdialog('open')"
		@closed="setdialog('close')"
	>
		<div class="errorwin">
			<div class="errormsg">
				<span>{{ errormsg }}</span>
			</div>
			<div class="tips">请扫描下方条码或者在输入框中填写 1A 再回车</div>
			<div><el-input v-model="errorcode" ref="errorcode" @keyup.enter.native="EnterEvent('errorcode')"></el-input></div>
			<div class="barcode"><img src="../../static/system_01/image/tmA.png" /></div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			showerrorwin: false,
			errormsg: '',
			errorcode: ''
		};
	},
	methods: {
		init(param) {
			var that=this;
			this.errorcode='';
			this.showerrorwin = true;
			this.errormsg = param.errormsg;
			this.$nextTick(function(){
				that.$refs.errorcode.focus();
			});
		},
		EnterEvent(control) {
			if (control == 'errorcode') {
				if (this.errorcode == '1a'||this.errorcode == '1A') {
					this.showerrorwin = false;
					this.errorcode = '';
				} else {
					this.ReadMsg('验证失败');
				}
			}
		},
		ReadMsg(msg) {
			if (this.$tool.checkprintcontrol()) {
				LODOP.FORMAT('VOICE:3;100', msg);
			}
		},
		setdialog(type) {
			if (type == 'open') {
				this.ReadMsg(this.errormsg);
			}
			this.$emit('errorwincallback', {
				type: type
			});
			
		}
	}
};
</script>

<style></style>
